import { store } from './store/store'

import Shell from './pages/Shell'
import Home from './pages/Home'
import Testimonials from './pages/Testimonials'
import Blog from './pages/Blog'
import Contact from './pages/Contact'
// import Results from './pages/Results'
import Help from './pages/Help'
import Buy from './pages/Buy'
import Picks from './pages/Picks'
import Register from './pages/Register'
import Login from './pages/Login'
import MyAccount from './pages/MyAccount'
import ChangePassword from './pages/ChangePassword'
import ForgotPassword from './pages/ForgotPassword'
import Admin from './pages/Admin'
import ManageRecord from './pages/ManageRecord'
import Purchase from './pages/Purchase'
import Size from './pages/Size'
import Shop from './pages/Shop'
import ProductDetail from './pages/ProductDetail'
import Cart from './pages/Cart'
import Checkout from './pages/Checkout'
import OrderConfirmation from './pages/OrderConfirmation'
import MyOrders from './pages/MyOrders'
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// Vue.extend(), or just a component options object.
export const routes = [
  {
    path: '/',
    component: Shell,
    children: [
      {
        path: '/',
        component: Home,
        name: 'home',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/testimonials',
        component: Testimonials,
        name: 'testimonials',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/blog',
        component: Blog,
        name: 'blog',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/contact',
        component: Contact,
        name: 'contact',
        beforeEnter: (to, from, next) => check(next)
      },
      // {path: '/results', component: Results, name: 'results', beforeEnter: (to, from, next) => check(next)},
      {
        path: '/purchase',
        component: Purchase,
        name: 'purchase'
      },
      {
        path: '/help',
        component: Help,
        name: 'help',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/buy',
        component: Buy,
        name: 'buy',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/picks',
        component: Picks,
        name: 'picks',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/myaccount',
        component: MyAccount,
        name: 'myaccount',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/changepassword',
        component: ChangePassword,
        name: 'changepassword',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/tools/size',
        component: Size,
        name: 'size',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/shop',
        component: Shop,
        name: 'shop'
      },
      {
        path: '/shop/:slug',
        component: ProductDetail,
        name: 'product-detail'
      },
      {
        path: '/cart',
        component: Cart,
        name: 'cart'
      },
      {
        path: '/checkout',
        component: Checkout,
        name: 'checkout',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/order-confirmation/:id',
        component: OrderConfirmation,
        name: 'order-confirmation',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/orders',
        component: MyOrders,
        name: 'orders',
        beforeEnter: (to, from, next) => check(next)
      },
      {
        path: '/admin',
        component: Admin,
        name: 'admin',
        beforeEnter: (to, from, next) => checkAdmin(next)
      },
      {
        path: '/managerecord',
        component: ManageRecord,
        name: 'managerecord',
        beforeEnter: (to, from, next) => checkAdmin(next)
      },
      { path: '/register', component: Register, name: 'register' },
      {
        path: '/forgotpassword',
        component: ForgotPassword,
        name: 'forgotpassword'
      },
      {
        path: '/login',
        component: Login,
        name: 'login',
        beforeEnter: (to, from, next) => checkSignIn(next)
      }
    ]
  }
]

function checkAdmin (next) {
  if (!store.state.currentUser || !store.state.currentUser.admin) {
    return next('/')
  }
  return next()
}

function check (next) {
  if (!store.state.currentUser) return next('/login')
  return next()
}

function checkSignIn (next) {
  if (store.state.currentUser) return next('/')
  return next()
}



// WEBPACK FOOTER //
// ./src/routes.js